export interface LabeledValue {
    label: any;
    value: any;
}

export function parseObject(source: Record<string, any> | { [key: string]: any }): Record<string, any> {
    if (Array.isArray(source)) {
        const newArray = [];
        for (let i = 0; i < source.length; i++) {
            if (typeof source[i] === 'object' && source[i] !== null) {
                if ('label' in source[i] && 'value' in source[i]) {
                    newArray[i] = source[i].value;
                } else {
                    newArray[i] = parseObject(source[i]);
                }
            } else {
                newArray[i] = source[i];
            }
        }
        return newArray;
    } else if (typeof source === 'object' && source !== null) {
        const newObj: Record<string, any> = {};
        for (const key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                const field = source[key];

                if (typeof field === 'object' && field !== null) {
                    if ('label' in field && 'value' in field) {
                        newObj[key] = field.value;
                    } else {
                        newObj[key] = parseObject(field);
                    }
                } else {
                    newObj[key] = field;
                }
            }
        }
        return newObj;
    } else {
        return source;
    }
}

export function removeNullValues(obj: { [key: string]: any }): { [key: string]: any } {
    const newObj: { [key: string]: any } = {};
    for (const key in obj) {
        if (obj[key] !== null) {
            newObj[key] = obj[key];
        }
    }
    return newObj;
}

/**
 * Removes all keys from an object except for the specified ones.
 *
 * @param obj - The object to filter.
 * @param keepKeys - An array of keys to keep in the resulting object.
 * @returns A new object containing only the specified keys and their values.
 */
export function removeExcept<T extends Record<string, unknown>>(obj: T, keepKeys: string[]): Partial<T> {
    const filteredObj: Partial<T> = {};
    for (const key in obj) {
        if (keepKeys.includes(key)) {
            filteredObj[key] = obj[key];
        }
    }
    return filteredObj;
}
